<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Rq67W2/tc-custom/9781473872004.jpg?1705433533704" alt="This image is the cover for the book Irish Railways in the 1950s and 1960s"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Irish Railways in the 1950s and 1960s
      </h1>
      <p class="bookDescription body article font2">
        <p>In the 1950s and 1960s the railway system in Ireland became a magnet for enthusiasts from Great Britain who realized that, as on the mainland, a way of life was fast disappearing as diesel traction replaced steam and the size of the rail network across Ireland was shrinking. Much of the interest stemmed from the similarity with the railways in Great Britain. Also, the existence of several narrow gauge systems, two railway-owned tramways and some cross-border operators added to the fascination. This album covers those main line and narrow gauge railways in Northern Ireland and the Republic of Ireland during the 1950s and 1960s, which were photographed in color and the images used are believed never to have appeared in print before. Although most of the pictures depict individual locomotives or ones hauling trains, the opportunity has been taken to show some of the railway infrastructure of the period as well, since this is of particular interest to railway modelers. There has been a very active preservation movement in Ireland over the years, with many wonderful steam-hauled rail tours being operated that continue to this day, however this book will focus on the normal every day operations.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin McCormack
      </h2>
      
      <p class="authorDescription body article">Kevin McCormack is a life-long railway enthusiast. He began with spotting books and later gravitated to photographing trains and eventually to railway preservation. Since 1973 he has owned a Victorian Great Western Railway saloon carriage, which he keeps at Didcot Railway Centre in Oxfordshire. He has written thirty-four Transport books so far.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0bb0e374